import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  bindScreeningCpf,
  createScreeningSession,
  getPublicScreeningModules,
  getScreeningNext,
  postScreeningAnswer,
  postScreeningContact
} from './requests'

export const usePublicScreeningModules = () =>
  useQuery({
    queryKey: ['screening-public-modules'],
    queryFn: getPublicScreeningModules,
    staleTime: 60_000
  })

export const useScreeningNext = (token?: string) =>
  useQuery({
    queryKey: ['screening-next', token],
    queryFn: () => getScreeningNext(token as string),
    enabled: Boolean(token)
  })

export const useCreateScreeningSession = () =>
  useMutation({
    mutationFn: ({ heroSlug, moduleSlug }: { heroSlug: string; moduleSlug?: string }) =>
      createScreeningSession(heroSlug, moduleSlug)
  })

export const useScreeningContact = (token: string) => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (payload: Record<string, unknown>) => postScreeningContact(token, payload),
    onSuccess: (data) => {
      client.setQueryData(['screening-next', token], data)
    }
  })
}

export const useScreeningAnswer = (token: string) => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (payload: { key: string; value: unknown }) => postScreeningAnswer(token, payload),
    onSuccess: (data) => {
      client.setQueryData(['screening-next', token], data)
    }
  })
}

export const useBindScreeningCpf = () =>
  useMutation({
    mutationFn: ({ token, cpf }: { token: string; cpf: string }) => bindScreeningCpf(token, cpf)
  })
